// @archigraph r8DljQiU

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
  className?: string;
}

export function ErrorMessage({
  message,
  onRetry,
  onDismiss,
  className = '',
}: ErrorMessageProps) {
  return (
    <div
      className={`bg-error-light border border-error/30 p-4 ${className}`}
      role="alert"
    >
      <div className="flex items-start gap-3">
        <span className="text-error text-sm flex-shrink-0 mt-0.5 font-mono">!</span>
        <div className="flex-1">
          <p className="text-xs text-error font-medium">{message}</p>
        </div>
        <div className="flex items-center gap-2">
          {onRetry && (
            <button
              onClick={onRetry}
              className="text-xs font-medium text-error hover:text-red-300 uppercase tracking-wider min-h-[44px] min-w-[44px] flex items-center justify-center"
              type="button"
            >
              Retry
            </button>
          )}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="text-error hover:text-red-300 min-h-[44px] min-w-[44px] flex items-center justify-center"
              aria-label="Dismiss error"
              type="button"
            >
              <span className="text-sm font-mono">&times;</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
